import React, { useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { API } from '../../config';
import CheckoutModal from './CheckoutModal';

const BuyButton = ({item, addrTo, email}) => {

    const [modalState, setModalState] = useState({title: '', description: '', open: false, link:'/'});
    const { title, description, open, link } = modalState;

    console.log(item.merchantId);
    const initalOptions = {
	'client-id': 'AVI48DNgiTqPu1z-NFROfddinmrFlbq7Z1ASitOxVDd4ldwJNEW6TqZ2k5yV-6gpSUOkuadR3HvM1U2R',
	currency:'USD',
        //'merchant-id': item.merchantId
        'merchant-id': 'HQTCABK6XZPT6', //TODO: figure out how merchants work with sandbox accounts

    };
    return (
	<div className='mt-2 flex: sm:flex-col1 relative z-0'>
            <CheckoutModal title={title} description={description} open={open} link={link}/>
	    <>
		<PayPalScriptProvider options={initalOptions}>
		    <PayPalButtons 
			className='flex sm:flex-col1 sm:w-full max-w-xs relative'
			forceReRender={[item.price]}
                        createOrder={(data, actions) => {
                            console.log('create order');
                            console.log('addrTo');
                            console.log(item._id);
                            const orderDetails = {addrTo, email, isGuest: true}
                            return fetch(`${API}/create-order/${item._id}`,  {
                                method: 'post',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                },
                                body: JSON.stringify(orderDetails)
                            })
                                .then(res => {
                                    return res.json();
                                })
                                .then(orderData => {
                                    return orderData.id;
                                });
                        }}
                        
                        onApprove={(data, actions) => {
                            return fetch(`${API}/capture-order/${data.orderID}`, {
                                method: 'post'
                            })
                                .then(res => {
                                    return res.json();
                                })
                                .then(orderData => {
                                    var errorDetail = Array.isArray(orderData.details) && orderData.details[0];

                                    if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
                                        return actions.restart()
                                    }

                                    if (errorDetail) {
                                        var msg = 'woops';
                                        if (errorDetail.description) msg += '\n\n' + errorDetail.description;
                                        if (orderData.debug_id) msg += ' (' + orderData.debug_id + ') ';
                                        return alert(msg); //TODO: Change to modal later
                                    }

                                    //success message
                                    console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
                                    var transaction = orderData.purchase_units[0].payments.captures[0];
                                    //alert('Transaction '+ transaction.status + ': ' + transaction.id + '\n\nSee console for all available details')
                                    setModalState({title: 'Transaction complete!', description: 'You can track this order on your orders page', open: true, link:'/orders'});

                                });
                        }}

                        onCancel={data => {
                            setModalState({
                                title: 'Transaction canceled',
                                description: 'You have not been charged',
                                open: true,
                                link: `/loot/${item._id}`
                            });
                        }}

                        onError={data => {
                            setModalState({
                                title: 'Transaction Error',
                                description: 'You have not been charged. Please Try Again',
                                open: true,
                                link: `/loot/${item._id}`
                            });
                        }}
		    />
		</PayPalScriptProvider>
	    </>
	</div>
    )
};

export default BuyButton;
